export default __webpack_public_path__ + "static/logo-full-5e519402e6140a2fb8b8707452711d86.png";